import React from "react";
import AdminDashboard from "../pages/AdminDashboard";
import StoreDashboard from "../pages/StoreDashboard";
import { getUserData } from "../utils/localStorage";
import StoreDashboardOrder from "./StoreDashboardOrder";
import WarehouseDashboardOrder from "./WarehouseDashboardOrder";
import SearchCustomer from "./SearchCustomer/SearchCustomer";
import CustomerInfo from "./CustomerInfo/CustomerInfo";
import GetAllOrder from "./CustomerInfo/GetAllOrder";
import CustomerInfoOrders from "./CustomerInfo/CustomerInfoOrders";
import EditCustomer from "./CustomerInfo/CustomerEdit/EditCustomer";
import BookNewOrder from "./BookNewOrder/BookNewOrder";
import GeneralBookingSelection from "./BookNewOrder/GeneralBookingSelection";
import CartPage from "./CartComponent/CartPage";
import OrdersGarmentInfo from "./OrderComponents/OrdersGarmentInfo";
import BookingChargesInfo from "./OrderComponents/BookingChargeInfo";
import GarmentEdit from "./OrderComponents/GarmentEdit";
import PartialMarkReady from "./OrderComponents/PartialMarkReady";
import DeliverOrder from "./OrderComponents/DeliverOrder";
import PaymentCollection from "./PaymentCollection/PaymentCollection";
import ViewInvoice from "./ViewInvoice/ViewInvoice";
import ViewQrCode from "./ViewQrCode/ViewQrCode";
import WalletLedgerSelection from "./CustomerComponent/WalletLedgerSelection";
import CustomerAccount from "./CustomerComponent/CustomerAccount";
import CustomerLedger from "./CustomerComponent/CustomerLedger";
import CustomerPackageOffer from "./CustomerComponent/PackageOffers/CustomerPackageOffer";
import CustomerPackageOfferLog from "./CustomerComponent/PackageOffers/CustomerPackageOfferLog";
import GarmentEditWithScanner from "./OrderComponents/GarmentEditWithScanner";
import Orders from "./Orders";
import DashboardPickupJob from "./RiderJobComponent/DashboardPickupJob";
import DashboardDeliveryJob from "./RiderJobComponent/DashboardDeliveryJob";
import WalletCollection from "./WalletCollection/WalletCollection";
import DashboardPaymentCollection from "./PaymentCollection/DashboardPaymentCollection";
import PickupJob from "./RiderJobComponent/PickupJob";
import Setting from "./SettingComponent/Setting";
import StoreUser from "./SettingComponent/StoreUser";
import StoreDiscount from "./SettingComponent/StoreDiscount";
import StoreCharges from "./SettingComponent/StoreCharges";
import StorePriceCode from "./SettingComponent/StorePriceCode";
import StoreUserProfile from "./SettingComponent/StoreUserProfile";
import OrderDelivered from "./OrderDelivered";
import RiderJobs from "./RiderJobComponent/RiderJobs";
import DeliveryJob from "./RiderJobComponent/DeliveryJob";
import StoreWarehouse from "./StoreWarehouse/StoreWarehouse";
import SendToWarehouse from "./StoreWarehouse/SendToWarehouse";
import ReceiveFromWarehouse from "./StoreWarehouse/ReceiveFromWarehouse";
import ChallanList from "./StoreChallan/ChallanList";
import ChallanQrCodeList from "./StoreChallan/ChallanQrCodeList";
import StoreProfile from "./StoreProfile";
import StoreGarmentStock from "./StoreStock/StoreGarmentStock";
import ThankYou from "./PaymentCollection/ThankYou";
import ThankYouCollectPayment from "./PaymentCollection/ThankYouCollectPayment";
import GarmentQrCodeList from "./GarmentInspection/GarmentQrCodeList";
import DashboardPaymentRefund from "./WalletCollection/DashboardPaymentRefund";
import PaymentCollectionReceipt from "./OrderComponents/PaymentCollectionReceipt";
import PackagePaymentReceipt from "./CustomerComponent/PackageOffers/PackagePaymentReceipt";
import ViewQrCodePrint from "./ViewQrCode/ViewQrCodePrint";
import RiderChallanComponent from "./OrderComponents/RiderChallanComponent";
import ChallanReceipt from "./StoreChallan/ChallanReceipt";
import WarehouseDashboardQrCodeList from "./Warehouse/WarehouseDashboardQrCodeList";
import WarehouseDashboardQrCodeListReceivedReady from "./Warehouse/WarehouseDashboardQrCodeListReceivedReady";
import WarehouseGarmentInspectionImages from "./Warehouse/WareHouseGarmentInspectionImages.js";
import WarehouseChallanList from "./Warehouse/WarehouseChallan/WarehouseChallanList.js";
import WarehouseChallanQrCodeList from "./Warehouse/WarehouseChallan/WarehouseChallanQrCodeList.js";
import WarehouseChallanReceipt from "./Warehouse/WarehouseChallan/WarehouseChallanReceipt.js";
import ReceiveFromStore from "./Warehouse/ReceiveFromStore.js";
import WarehouseQrCodeList from "./Warehouse/WarehouseQrCodeList.js";
import WarehouseOrderProcess from "./Warehouse/WarehouseOrderProcess.js";
import SendToStore from "./Warehouse/SendToStore.js";
import SelectStoreInAdmin from "./SelectStoreInAdmin.js";
import AdminDashboardOrder from "./AdminDashboardOrder.js";
import AdminOrders from "./AdminOrders.js";
import UserList from "./AdminComponent/UserManagement/UserList.js";
import StoreManagementList from "./AdminComponent/StoreManagement/StoreManagementList.js";
import StoreManagementCreate from "./AdminComponent/StoreManagement/StoreManagementCreate.js";
import StoreConfigList from "./AdminComponent/StoreManagement/StoreConfigList.js";
import StoreConfigUser from "./AdminComponent/StoreManagement/StoreConfigUser.js";
import StoreConfigPrice from "./AdminComponent/StoreManagement/StoreConfigPrice.js";
import StoreConfigPackage from "./AdminComponent/StoreManagement/StoreConfigPackage.js";
import StoreConfigCharges from "./AdminComponent/StoreManagement/StoreConfigCharges.js";
import StoreConfigDiscount from "./AdminComponent/StoreManagement/StoreConfigDiscount.js";
import StoreConfigOffer from "./AdminComponent/StoreManagement/StoreConfigOffer.js";
import StoreConfigPackageOffer from "./AdminComponent/StoreManagement/StoreConfigPackageOffer.js";
import StoreConfigPaymentGatewayView from "./AdminComponent/StoreManagement/PaymentGatewayConfig/StoreConfigPaymentGatewayView.js";
import WarehouseManagementList from "./AdminComponent/WarehouseManagement/WarehouseManagementList.js";
import WarehouseManagementCreate from "./AdminComponent/WarehouseManagement/WarehouseManagementCreate.js";
import WarehouseConfigList from "./AdminComponent/WarehouseManagement/WarehouseConfigList.js";
import WarehouseConfigStores from "./AdminComponent/WarehouseManagement/WarehouseConfigStores.js";
import WarehouseProcessStageList from "./AdminComponent/WarehouseManagement/WarehouseProcessStageList.js";
import WarehouseConfigUsers from "./AdminComponent/WarehouseManagement/WarehouseConfigUsers.js";
import WarehouseProcessStageUsers from "./AdminComponent/WarehouseManagement/WarehouseProcessStageUsers.js";
import ChargesAndDiscountList from "./AdminComponent/ChargesAndDiscount/ChargesAndDiscountList.js";
import AppServiceList from "./AdminComponent/AppServices/AppServiceList.js";
import GarmentPack from "./AdminComponent/GarmentPack/GarmentPack.js";
import TariffList from "./AdminComponent/PriceListManagement/TariffList.js";
import PriceList from "./AdminComponent/PriceListManagement/PriceList.js";
import PackageTariffList from "./AdminComponent/PriceListManagement/PackageTariffList.js";
import OffersManagement from "./AdminComponent/OffersManagement/OffersManagement.js";
import OffersManagementCreate from "./AdminComponent/OffersManagement/OffersManagementCreate.js";
import PackageOfferManagement from "./AdminComponent/PackageOfferManagement.js/PackageOfferManagement.js";
import PackageOfferCreate from "./AdminComponent/PackageOfferManagement.js/PackageOfferCreate.js";
import BrandTermAndCondition from "./AdminComponent/BrandTermAndCondition/BrandTermAndCondition.js";
import BrandTermAndConditionCreate from "./AdminComponent/BrandTermAndCondition/BrandTermAndConditionCreate.js";
import LocalityView from "./AdminComponent/Locality/LocaityView.js";
import LocalityCreate from "./AdminComponent/Locality/LocalityCreate.js";
import PaymentGatewayConfigView from "./AdminComponent/PaymentGatewayConfig/PayementGatewayConfigView.js";
import PaymentGatewayConfigCreate from "./AdminComponent/PaymentGatewayConfig/PaymentGatewayConfigCreate.js";
import GarmentRemarksList from "./AdminComponent/GarmentRemarks/GarmentRemarksList.js";
import GarmentRemarksDetailList from "./AdminComponent/GarmentRemarks/GarmentRemarksDetailList.js";
import GarmentRemarksCreate from "./AdminComponent/GarmentRemarks/GarmentRemarksCreate.js";
import DashboardPickupRequest from "./AdminComponent/Dashboard/DashboardPickupRequest.js";
import UserCreateDashboard from "./AdminComponent/UserManagement/UserCreateDashboard.js";
import BrandCustomerList from "./AdminComponent/BrandCustomer/BrandCustomerList.js";
import AdminOrderDelivered from "./AdminComponent/Orders/AdminOrderDelivered.js";
import BrandOldOrder from "./AdminComponent/BandOldOrder/BrandOldOrder.js";
import AdminDashboardPickupJob from "./AdminComponent/AdminRiderJobComponent/AdminDashboardPickupJob.js";
import AdminDashboardDeliveryJob from "./AdminComponent/AdminRiderJobComponent/AdminDashboardDeliveryJob.js";
import AdminOrdersGarmentInfo from "./OrderComponents/AdminOrdersGarmentInfo.js";
import StoreNotificationView from "./AdminComponent/StoreManagement/StoreNotificationView.js";
import Reports from "./AdminComponent/Reports/Report.js";
import GarmentStock from "./AdminComponent/Reports/GarmentStock.js";
import BarChart from "./AdminComponent/Reports/BarChart.js";
import AnalyticsList from "./AdminComponent/Analytics/AnalyticsList.js";
import OrderSaleAnalyticsNew from "./AdminComponent/Analytics/OrderSaleAnalyticsNew.js";
import TopPerformerNew from "./AdminComponent/Analytics/TopPerformerNew.js";
import TopServicesNew from "./AdminComponent/Analytics/TopServicesNew.js";
import TopGarmentsNew from "./AdminComponent/Analytics/TopGarmentsNew.js";
import ProcessStatus from "./AdminComponent/Analytics/ProcessStatus.js";
import OverallRevenue from "./AdminComponent/Analytics/OverallRevenue.js";
import CustomerOldOrderLedger from "./CustomerComponent/OldOrder/CustomerOldLedger.js";
import WarehouseDashboard from "./WarehouseDashboard.js";
import WarehouseDashboardQrCodeListStageWise from "./Warehouse/WarehouseDashboardQrCodeListStageWise.js";
import SubscriptionAppliedSuccessfully from "./PaymentCollection/SubscriptionAppliedSuccessfully.js";
import Cashbook from "./AdminComponent/Cashbook/Cashbook.js";
import StoreCashbook from "./StoreCashBook.js";
import IncomeExpense from "./AdminComponent/IncomeExpense/IncomeExpense.js";
import StoreIncomeExpense from "./SettingComponent/StoreIncomeExpense/StoreIncomeExpense.js";
import IncomeExpenseSelection from "./AdminComponent/IncomeExpense/IncomeExpenseSelection.js";
import StoreWiseIncomeExpense from "./AdminComponent/IncomeExpense/StoreWiseIncomeExpense.js";
import DashboardPaymentCollecionReceipt from "./PaymentCollection/DashboardPaymentCollectionReceipt.js";
import DashboardPaymentCollectionReceipt from "./PaymentCollection/DashboardPaymentCollectionReceipt.js";
import ReportsView from "./AdminComponent/Reports/ReportsView.js";
import UPIDisclaimer from "./AdminComponent/StoreManagement/UPIDisclaimer.js";
import ReadyToSendToWareHouse from "./StoreWarehouse/ReadyToSendToWareHouse.js";
import ReadyToSendToStoreByWarehouse from "./Warehouse/ReadyToSendToStoreByWarehouse.js";
import OrderDeliveredComponent from "./OrderComponents/OrderDeliveredComponent.js";
import QrCodeByItem from "./OrderComponents/QrCodeByItem.js";
import StoreExternalWarehouseChallan from "./StoreExternalWarehouseChallan/StoreExternalWarehouseChallan.js";
import StoreExternalWarehouseChallanAdd from "./StoreExternalWarehouseChallan/StoreExternalWarehouseChallanAdd.js";
import StoreExternalWarehouseQrCode from "./StoreExternalWarehouseChallan/StoreExternalWarehouseQrCode.js";
import StoreExternalWarehouseChallanQrcodeData from "./StoreExternalWarehouseChallan/StoreExternalWarehouseChallanQrcodeData.js";
import StoreExternalWHChallanComponent from "./StoreExternalWarehouseChallan/StoreExternalWHChallanComponent.js";
import StorePrinterSetting from "./SettingComponent/StorePrinters/StorePrinterSetting.js";
import StoreReports from "./StoreReport/StoreReports.js";
import BulkProcessingList from "./AdminComponent/StoreManagement/BulkProcessing/BulkProcessingList.js";
import BulkProcessing from "./AdminComponent/StoreManagement/BulkProcessing/BulkProcessing.js";
import BulkOutForDelivery from "./AdminComponent/StoreManagement/BulkProcessing/BulkOutForDelivery.js";
import BulkProcessingAdmin from "./AdminComponent/StoreManagement/BulkProcessing/BulkProcessingAdmin.js";
import StoreReportCollectionReceipt from "./StoreReport/StoreReportCollectionReceipt.js";
import AdminReports from "./StoreReport/AdminReports.js";
import WalletCollectionReceipt from "./WalletCollection/WalletCollectionReceipt.js";
import TariffManagement from "../tariff/TariffManagement.js";
import PriceListSelection from "../tariff/PriceListSelection.js";
import PackageListSelection from "../tariff/PackageListSelection.js";
import PriceListTariff from "../tariff/PriceListTariff.js";
import PackageList from "../tariff/PackageList.js";
import GarmentTag from "../tariff/GarmentTag.js";
import OfferManagement from "../tariff/OfferManagement/OfferManagement.jsx";
import PackageOfferManagementTariff from "../tariff/PackageOfferManagement/PackageOfferManagementTariff.jsx";
import OfferGarmentSelection from "../tariff/OfferManagement/OffersGarmentSelection.jsx";
import PackageOffersGarmentSelection from "../tariff/PackageOfferManagement/PackageOffersGarmentSelection.jsx";
import TrackOrder from "../tariff/TrackOrder/TrackOrder.js";
import MyPriceListTariff from "../tariff/MyPriceListTariff.js";
import MyPackageList from "../tariff/MyPackageList.js";
import MyOfferGarmentSelection from "../tariff/OfferManagement/MyOfferGarmentSelection.jsx";
import WhatsappNotification from "./WhatsappNotification.js";
import WhatsappNotificationAdmin from "./WhatsappNotificationAdmin.js";
import TimeSlotList from "./AdminComponent/TimeSlotManagement/TimeSlotList.js";
import TimeSlotCreate from "./AdminComponent/TimeSlotManagement/TimeSlotCreate.js";
import PackageLogAdmin from "./CustomerComponent/PackageLog/PackageLogAdmin.js";
import PackageLogStore from "./CustomerComponent/PackageLog/PackageLogStore.js";
import CustomerSubscription from "./CustomerComponent/CustomerSubscription.js";
import CustomerPackageLog from "./CustomerComponent/PackageLog/CustomerPackageLog.js";
import LoyaltyPointList from "./AdminComponent/LoyaltyPointManagement/LoyaltyPointList.js";
import CustomerLoyaltyPointLog from "./CustomerComponent/CustomerLoyaltyPointLog/CustomerLoyaltyPointLog.js";
import LoyaltyPointRedeemNow from "./PaymentCollection/LoyaltyPointRedeemNow.js";
import CustomerLoyaltyPointPointLog from "./CustomerComponent/CustomerLoyaltyPointLog/CustomerLoyaltyPointPointLog.js";
import CustomerLoyaltyPointCashLog from "./CustomerComponent/CustomerLoyaltyPointLog/CustomerLoyaltyPointCashLog.js";
import PriceListSelectionByStore from "../tariff/PriceListSelectionByStore.js";
import PackageListSelectionByStore from "../tariff/PackageListSelectionByStore.js";
import BookingDiscountInfo from "./OrderComponents/BookingDiscountInfo.js";
import SubscriptionPackage from "./CustomerComponent/SubscriptionPackage.js";
import SubscriptionPackageInfoStore from "./CustomerComponent/PackageLog/SubscriptionPackageInfoStore.js";
import AllCustomerPackageOfferLog from "./CustomerComponent/PackageOffers/AllCustomerPackageOfferLog.js";
import SubscriptionPackageInfoAdmin from "./CustomerComponent/PackageLog/SubscriptionPackageInfoAdmin.js";
import OrderDeliveredComponentMenu from "./OrderComponents/OrderDeliveredComponentMenu.js";
import StoreDashboardNew from "./StoreDashboardNew.js";
import AdminDashboardNew from "./AdminDashboardNew.js";
import FranchiseManagementList from "./AdminComponent/FranchiseModal/FranchiseManagementList.js";
import FranchiseManagementCreate from "./AdminComponent/FranchiseModal/FranchiseManagementCreate.js";
import FranchiseStoreMap from "./AdminComponent/FranchiseModal/FranchiseStoreMap.js";
import FranchiseStoreMappedList from "./AdminComponent/FranchiseModal/FranchiseStoreMappedList.js";
import FranchiseConfigList from "./AdminComponent/FranchiseModal/FranchiseConfigList.js";
import FranchisesRateList from "./AdminComponent/FranchiseModal/FranchisesRateList.js";
import FranchisesRateCreate from "./AdminComponent/FranchiseModal/FranchisesRateCreate.js";
import FranchiseUserMappedList from "./AdminComponent/FranchiseModal/FranchiseUserMappedList.js";
import FranchiseUserMap from "./AdminComponent/FranchiseModal/FranchiseUserMap.js";
import FranchiseAdminDashboardNew from "./FranchiseAdminDashboardNew.js";
import FranchiseStoreOrderRevenue from "./FranchiseModal/FranchiseStoreOrderRevenue.js";
import FranchiseStoreServiceWiseRevenue from "./FranchiseModal/FranchiseStoreServiceWiseRevenue.js";
import FranchiseStoreOrderRevenueAdmin from "./FranchiseModal/FranchiseStoreOrderRevenueAdmin.js";
import FranchiseStoreServiceWiseRevenueAdmin from "./FranchiseModal/FranchiseStoreServiceWiseRevenueAdmin.js";
import FranchiseAdminOrders from "./FranchiseModal/FranchiseAdminOrders.js";
import FranchiseAdminDashboard from "./FranchiseAdminDashboard.js";
import FranchiseStoreListAdmin from "./AdminComponent/FranchiseModal/FranchiseStoreListAdmin.js";
import FranchiseStoreList from "./AdminComponent/FranchiseModal/FranchiseStoreList.js";
import PaymentCollectionReceiptAdmin from "./OrderComponents/PaymentCollectionReceiptAdmin.js";
import AdminSearchCustomer from "./SearchCustomer/AdminSearchCustomer.js";
import CustomerInfoAdmin from "./CustomerInfo/CustomerInfoAdmin.js";
import OrderDeliveredComponentAdmin from "./OrderComponents/OrderDeliveredComponentAdmin.js";
import WalletLedgerSelectionAdmin from "./CustomerComponent/WalletLedgerSelectionAdmin.js";
import PackagePaymentReceiptAdmin from "./CustomerComponent/PackageOffers/PackagePaymentReceiptAdmin.js";
import CustomerInfoOrdersAdmin from "./CustomerInfo/CustomerInfoOrdersAdmin.js";
import GetAllOrderAdmin from "./CustomerInfo/GetAllOrderAdmin.js";
import EditCustomerAdmin from "./CustomerInfo/CustomerEdit/EditCustomerAdmin.js";
import PackageLogAdminWithUpdate from "./CustomerComponent/PackageLog/PackageLogAdminWithUpdate.js";
import GarmentQrCodeListAdmin from "./GarmentInspection/GarmentQrCodeListAdmin.js";
import GarmentRFIDList from "./GarmentInspection/GarmentRFIDList.js";
import CheckGarmentRFID from "./GarmentInspection/CheckGarmentRFID.js";
import StoreCustomerIdConfigList from "./AdminComponent/StoreManagement/StoreCustomerIdConfigList.js";
import StoreCustomerIdConfigAdd from "./AdminComponent/StoreManagement/StoreCustomerIdConfigAdd.js";
import BrandBannerView from "./AdminComponent/BrandBanner/BrandBannerView.js";
import PromoTemplateView from "./AdminComponent/PromoManagement/PromoTemplateView.js";
import PromoTemplateCreate from "./AdminComponent/PromoManagement/PromoTemplateCreate.js";
import PromoTemplateCustomerView from "./AdminComponent/PromoManagement/PromoTemplateCustomerView";
import CustomerPackageOfferSubscriptionLog from "./CustomerComponent/PackageOffers/CustomerPackageOfferSubscriptionLog.js";
import CustomerSubscriptionTransferToWallet from "./CustomerComponent/PackageOffers/CustomerSubscriptionTransferToWallet.js";
import CustomerPackageOfferLogNew from "./CustomerComponent/PackageOffers/CustomerPackageOfferLogNew.js";
import PaymentModeList from "./AdminComponent/PaymentModeManagement/PaymentModeList.js";
import PaymentModeCreate from "./AdminComponent/PaymentModeManagement/PaymentModeCreate.js";
import B2BOrdersGarmentInfo from "./OrderComponents/B2BModal/B2BOrdersGarmentInfo.js";
import B2BChallanList from "./B2BModel/B2BChallanList.js";
import B2BChallanAdminList from "./B2BModel/B2BChallanAdminList.js";
import B2BAdminOrdersGarmentInfo from "./OrderComponents/B2BModal/B2BAdminOrdersGarmentInfo.js";
import B2BGetAllOrder from "./B2BModel/B2BGetAllOrder.js";
import B2BDeliveredChallanViewList from "./B2BModel/B2BDeliveredChallanViewList.js";
import RackModelStore from "./RackModelStore.js";
import RackModelAdmin from "./AdminComponent/Orders/RackModelAdmin.js";
import PackageTagView from "./ViewQrCode/PackageTagView.js";
import B2BChallanComponent from "./B2BModel/B2BChallanComponent.js";
import GeoLocationView from "./AdminComponent/StoreManagement/GeoLocationView.js";
import CustomerFeedBack from "./CustomerFeedBack.js";
import SwitchRiderUserList from "./AdminComponent/UserManagement/SwitchRiderUserList.js";
import PickupJobAdmin from "./RiderJobComponent/PickupJobAdmin.js";
import DeliveryJobAdmin from "./RiderJobComponent/DeliveryJobAdmin.js";
import B2BChallanPrint from "./B2BModel/B2BChallanPrint.js";
import CustomerAddressLocation from "./CustomerAddressLocation.js";
import PickupDeliveryMap from "./PickupDeliveryMap.js";
import SupportAdminDashboardNew from "./SupportAdminDashboardNew.js";
import SupportAdminDashboard from "./SupportAdminDashboard.js";
import ViewInvoiceSupport from "./ViewInvoice/ViewInvoiceSupport.js";
import StorePartialBooking from "./StorePartialBooking.js";

// Role-based dashboard selection
export const DashboardRole = () => {
  const { userProfileRole } = getUserData();
  switch (userProfileRole) {
    case "BY_ADMIN":
      return <AdminDashboardNew />;
    // return <AdminDashboard />;
    case "BY_SUB_ADMIN_USER":
      return <AdminDashboardNew />;
    // return <AdminDashboard />;
    case "BY_STORE":
      return <StoreDashboardNew />;
    // return <StoreDashboard />;
    case "BY_WAREHOUSE":
      return <WarehouseDashboard />;
    case "BY_FRANCHISE_ADMIN":
      return <FranchiseAdminDashboardNew />;
    case "BY_SUPPORT_ADMIN":
      return <SupportAdminDashboardNew />
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const DashboardNewRoute = () => {
  const { userProfileRole } = getUserData();
  switch (userProfileRole) {
    case "BY_STORE":
      // return <StoreDashboardNew />;
      return <StoreDashboard />;
    case "BY_ADMIN":
      return <AdminDashboard />;
    case "BY_SUB_ADMIN_USER":
      return <AdminDashboard />;
    case "BY_FRANCHISE_ADMIN":
      return <FranchiseAdminDashboard />;
    case "BY_SUPPORT_ADMIN":
      return <SupportAdminDashboard />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const DashboardOrder = () => {
  const { userProfileRole } = getUserData();
  switch (userProfileRole) {
    case "BY_ADMIN":
      return <AdminDashboardOrder />;
    case "BY_SUB_ADMIN_USER":
      return <AdminDashboardOrder />;
    case "BY_STORE":
      return <StoreDashboardOrder />;
    case "BY_FRANCHISE_ADMIN":
      return <AdminDashboardOrder />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const DashboardSearchCustomer = () => {
  const { userProfileRole } = getUserData();
  switch (userProfileRole) {
    case "BY_ADMIN":
      return <AdminSearchCustomer />;
      case "BY_SUB_ADMIN_USER":
        return <AdminSearchCustomer />;
    case "BY_STORE":
      return <SearchCustomer />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const CustomerInfoRoute = () => {
  const { userProfileRole } = getUserData();
  switch (userProfileRole) {
    case "BY_ADMIN":
      return <CustomerInfoAdmin />;
      case "BY_SUB_ADMIN_USER":
        return <CustomerInfoAdmin />;
    case "BY_STORE":
      return <CustomerInfo />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const CustomerInfoGetAllOrderRoute = () => {
  const { userProfileRole } = getUserData();
  switch (userProfileRole) {
    case "BY_ADMIN":
      return <GetAllOrderAdmin />;
      case "BY_SUB_ADMIN_USER":
        return <GetAllOrderAdmin />;
    case "BY_STORE":
      return <GetAllOrder />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const CustomerInfoOrdersRoute = () => {
  const { userProfileRole } = getUserData();
  switch (userProfileRole) {
    case "BY_ADMIN":
      return <CustomerInfoOrdersAdmin />;
      case "BY_SUB_ADMIN_USER":
        return <CustomerInfoOrdersAdmin />;
    case "BY_STORE":
      return <CustomerInfoOrders />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const CustomerInfoEditCustomerRoute = () => {
  const { userProfileRole } = getUserData();
  switch (userProfileRole) {
    case "BY_ADMIN":
      return <EditCustomerAdmin />;
    case "BY_SUB_ADMIN_USER":
      return <EditCustomerAdmin />;
    case "BY_STORE":
      return <EditCustomer />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const BookNewOrderRoute = () => {
  const { userProfileRole } = getUserData();
  switch (userProfileRole) {
    case "BY_STORE":
      return <BookNewOrder />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const GeneralBookingSelectionRoute = () => {
  const { userProfileRole } = getUserData();
  switch (userProfileRole) {
    case "BY_STORE":
      return <GeneralBookingSelection />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const CartPageRoute = () => {
  const { userProfileRole } = getUserData();
  switch (userProfileRole) {
    case "BY_STORE":
      return <CartPage />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const OrdersGarmentInfoRoute = () => {
  const { userProfileRole } = getUserData();
  switch (userProfileRole) {
    case "BY_ADMIN":
      return <AdminOrdersGarmentInfo />;
      case "BY_SUB_ADMIN_USER":
        return <AdminOrdersGarmentInfo />;
    case "BY_STORE":
      return <OrdersGarmentInfo />;
      case "BY_FRANCHISE_ADMIN":
        return <AdminOrdersGarmentInfo />;
    case "BY_SUPPORT_ADMIN":
      return <AdminOrdersGarmentInfo />
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const BookingChargesInfoRoute = () => {
  const { userProfileRole } = getUserData();
  switch (userProfileRole) {
    case "BY_ADMIN":
      return <BookingChargesInfo />;
    case "BY_SUB_ADMIN_USER":
      return <BookingChargesInfo />;
    case "BY_FRANCHISE_ADMIN":
      return <BookingChargesInfo />;
    case "BY_STORE":
      return <BookingChargesInfo />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const BookingDiscountInfoRoute = () => {
  const { userProfileRole } = getUserData();
  switch (userProfileRole) {
    case "BY_ADMIN":
      return <BookingDiscountInfo />;
    case "BY_SUB_ADMIN_USER":
      return <BookingDiscountInfo />;
    case "BY_FRANCHISE_ADMIN":
      return <BookingDiscountInfo />;
    case "BY_STORE":
      return <BookingDiscountInfo />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};
export const GarmentEditRoute = () => {
  const { userProfileRole } = getUserData();
  switch (userProfileRole) {
    case "BY_STORE":
      return <GarmentEdit />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const PartialMarkReadyRoute = () => {
  const { userProfileRole } = getUserData();
  switch (userProfileRole) {
    case "BY_STORE":
      return <PartialMarkReady />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const DeliverOrderRoute = () => {
  const { userProfileRole } = getUserData();
  switch (userProfileRole) {
    case "BY_STORE":
      return <DeliverOrder />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const PaymentCollectionRoute = () => {
  const { userProfileRole } = getUserData();
  switch (userProfileRole) {
    case "BY_STORE":
      return <PaymentCollection />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const ViewInvoiceRoute = () => {
  const { userProfileRole } = getUserData();
  switch (userProfileRole) {
    case "BY_ADMIN":
      return <ViewInvoice />;
      case "BY_SUB_ADMIN_USER":
        return <ViewInvoice />;
    case "BY_STORE":
      return <ViewInvoice />;
      case "BY_FRANCHISE_ADMIN":
        return <ViewInvoice />;
    case "BY_SUPPORT_ADMIN":
      return <ViewInvoiceSupport />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const ViewQrCodeRoute = () => {
  const { userProfileRole } = getUserData();
  switch (userProfileRole) {
    case "BY_STORE":
      return <ViewQrCode />;
    case "BY_ADMIN":
      return <ViewQrCode />;
    case "BY_SUB_ADMIN_USER":
      return <ViewQrCode />;    
    case "BY_FRANCHISE_ADMIN":
      return <ViewQrCode />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const WalletLedgerSelectionRoute = () => {
  const { userProfileRole } = getUserData();
  switch (userProfileRole) {
    case "BY_ADMIN":
      return <WalletLedgerSelectionAdmin />;
    case "BY_SUB_ADMIN_USER":
      return <WalletLedgerSelectionAdmin />;
    case "BY_STORE":
      return <WalletLedgerSelection />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const CustomerAccountRoute = () => {
  const { userProfileRole } = getUserData();
  switch (userProfileRole) {
    case "BY_ADMIN":
      return <CustomerAccount />;
    case "BY_SUB_ADMIN_USER":
      return <CustomerAccount />;
    case "BY_STORE":
      return <CustomerAccount />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const CustomerLedgerRoute = () => {
  const { userProfileRole } = getUserData();
  switch (userProfileRole) {
    case "BY_ADMIN":
      return <CustomerLedger />;
    case "BY_SUB_ADMIN_USER":
      return <CustomerLedger />;
    case "BY_STORE":
      return <CustomerLedger />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const CustomerPackageOfferRoute = () => {
  const { userProfileRole } = getUserData();
  switch (userProfileRole) {
    case "BY_ADMIN":
      return <CustomerPackageOffer />;
    case "BY_SUB_ADMIN_USER":
      return <CustomerPackageOffer />;
    case "BY_STORE":
      return <CustomerPackageOffer />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const CustomerSubscriptionTransferToWalletRoute = () => {
  const { userProfileRole } = getUserData();
  switch (userProfileRole) {
    case "BY_ADMIN":
      return <CustomerSubscriptionTransferToWallet />;
    case "BY_SUB_ADMIN_USER":
      return <CustomerSubscriptionTransferToWallet />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const CustomerPackageOfferLogRoute = () => {
  const { userProfileRole } = getUserData();
  switch (userProfileRole) {
    case "BY_ADMIN":
      return <CustomerPackageOfferLog />;
    case "BY_SUB_ADMIN_USER":
      return <CustomerPackageOfferLog />;
    case "BY_STORE":
      return <CustomerPackageOfferLog />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const CustomerPackageOfferSubscriptionLogRoute = () => {
  const { userProfileRole } = getUserData();
  switch (userProfileRole) {
    case "BY_ADMIN":
      return <CustomerPackageOfferSubscriptionLog />;
    case "BY_SUB_ADMIN_USER":
      return <CustomerPackageOfferSubscriptionLog />;
    case "BY_STORE":
      return <CustomerPackageOfferSubscriptionLog />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const CustomerPackageOfferLogNewRoute = () => {
  const { userProfileRole } = getUserData();
  switch (userProfileRole) {
    case "BY_ADMIN":
      return <CustomerPackageOfferLogNew />;
    case "BY_SUB_ADMIN_USER":
      return <CustomerPackageOfferLogNew />;
    case "BY_STORE":
      return <CustomerPackageOfferLogNew />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const GarmentEditWithScannerRoute = () => {
  const { userProfileRole } = getUserData();
  switch (userProfileRole) {
    case "BY_STORE":
      return <GarmentEditWithScanner />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const OrdersRoute = () => {
  const { userProfileRole } = getUserData();
  switch (userProfileRole) {
    case "BY_ADMIN":
      return <AdminOrders />;
      case "BY_SUB_ADMIN_USER":
        return <AdminOrders />;
    case "BY_STORE":
      return <Orders />;
    case "BY_WAREHOUSE":
      return <WarehouseQrCodeList />;
    case "BY_FRANCHISE_ADMIN": 
      return <FranchiseAdminOrders />;
    case "BY_SUPPORT_ADMIN":
      return <AdminOrders />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const DashboardPickupJobRoute = () => {
  const { userProfileRole } = getUserData();
  switch (userProfileRole) {
    case "BY_STORE":
      return <DashboardPickupJob />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const DashboardDeliveryJobRoute = () => {
  const { userProfileRole } = getUserData();
  switch (userProfileRole) {
    case "BY_STORE":
      return <DashboardDeliveryJob />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const WalletCollectionRoute = () => {
  const { userProfileRole } = getUserData();
  switch (userProfileRole) {
    case "BY_ADMIN":
      return <WalletCollection />;
      case "BY_SUB_ADMIN_USER":
        return <WalletCollection />;
    case "BY_STORE":
      return <WalletCollection />;
      case "BY_FRANCHISE_ADMIN":
        return <WalletCollection />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const DashboardPaymentCollectionRoute = () => {
  const { userProfileRole } = getUserData();
  switch (userProfileRole) {
    case "BY_ADMIN":
      return <DashboardPaymentCollection />;
      case "BY_SUB_ADMIN_USER":
        return <DashboardPaymentCollection />;
    case "BY_STORE":
      return <DashboardPaymentCollection />;
      case "BY_FRANCHISE_ADMIN":
        return <DashboardPaymentCollection />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const PickupJobRoute = () => {
  const { userProfileRole } = getUserData();
  switch (userProfileRole) {
    case "BY_STORE":
      return <PickupJob />;
    case "BY_ADMIN":
      return <PickupJobAdmin />;
      case "BY_SUB_ADMIN_USER":
      return <PickupJobAdmin />;
        case "BY_FRANCHISE_ADMIN": 
      return <PickupJobAdmin />;
    case "BY_SUPPORT_ADMIN":
      return <PickupJobAdmin />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const PickupJobFormRoute = () => {
  const { userProfileRole } = getUserData();
  switch (userProfileRole) {
    case "BY_ADMIN":
      return <DashboardPickupRequest />;
    case "BY_SUB_ADMIN_USER":
      return <DashboardPickupRequest />;
    case "BY_FRANCHISE_ADMIN":
      return <DashboardPickupRequest />;
    case "BY_SUPPORT_ADMIN":
      return <DashboardPickupRequest />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const SettingRoute = () => {
  const { userProfileRole } = getUserData();
  switch (userProfileRole) {
    case "BY_STORE":
      return <Setting />;
    case "BY_ADMIN":
      return <Setting />;
      case "BY_SUB_ADMIN_USER":
        return <Setting />;
    case "BY_WAREHOUSE":
      return <Setting />;
     case "BY_FRANCHISE_ADMIN": 
      return <Setting />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const StoreUserRoute = () => {
  const { userProfileRole } = getUserData();
  switch (userProfileRole) {
    case "BY_STORE":
      return <StoreUser />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const StoreDiscountRoute = () => {
  const { userProfileRole } = getUserData();
  switch (userProfileRole) {
    case "BY_STORE":
      return <StoreDiscount />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};
export const StoreChargesRoute = () => {
  const { userProfileRole } = getUserData();
  switch (userProfileRole) {
    case "BY_STORE":
      return <StoreCharges />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const StorePriceCodeRoute = () => {
  const { userProfileRole } = getUserData();
  switch (userProfileRole) {
    case "BY_STORE":
      return <StorePriceCode />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const StoreUserProfileRoute = () => {
  const { userProfileRole } = getUserData();
  switch (userProfileRole) {
    case "BY_ADMIN":
      return <StoreUserProfile />;
      case "BY_SUB_ADMIN_USER":
        return <StoreUserProfile />;
    case "BY_STORE":
      return <StoreUserProfile />;
      case "BY_FRANCHISE_ADMIN":
        return <StoreUserProfile />;
    case "BY_SUPPORT_ADMIN":
      return <StoreUserProfile />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const OrderDeliveredRoute = () => {
  const { userProfileRole } = getUserData();
  switch (userProfileRole) {
    case "BY_STORE":
      return <OrderDelivered />;
    case "BY_ADMIN":
      return <AdminOrderDelivered />;
      case "BY_SUB_ADMIN_USER":
        return <AdminOrderDelivered />;
        case "BY_FRANCHISE_ADMIN": 
        return <AdminOrderDelivered />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const RiderJobsRoute = () => {
  const { userProfileRole } = getUserData();
  switch (userProfileRole) {

    case "BY_STORE":
      return <RiderJobs />;
    case "BY_ADMIN":
      return <RiderJobs />;
    case "BY_SUB_ADMIN_USER":
      return <RiderJobs />;
    case "BY_FRANCHISE_ADMIN":
      return <RiderJobs />;
    case "BY_SUPPORT_ADMIN":
      return <RiderJobs />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const DeliveryJobRoute = () => {
  const { userProfileRole } = getUserData();
  switch (userProfileRole) {
    case "BY_STORE":
      return <DeliveryJob />;
    case "BY_ADMIN":
      return <DeliveryJobAdmin />;
    case "BY_SUB_ADMIN_USER":
      return <DeliveryJobAdmin />;
    case "BY_FRANCHISE_ADMIN":
      return <DeliveryJobAdmin />;
    case "BY_SUPPORT_ADMIN":
      return <DeliveryJobAdmin />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const StoreWarehouseRoute = () => {
  const { userProfileRole } = getUserData();
  switch (userProfileRole) {
    case "BY_STORE":
      return <StoreWarehouse />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const SendToWarehouseRoute = () => {
  const { userProfileRole } = getUserData();
  switch (userProfileRole) {
    case "BY_STORE":
      return <SendToWarehouse />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const ReceiveFromWarehouseRoute = () => {
  const { userProfileRole } = getUserData();
  switch (userProfileRole) {
    case "BY_STORE":
      return <ReceiveFromWarehouse />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const ChallanListRoute = () => {
  const { userProfileRole } = getUserData();
  switch (userProfileRole) {
    case "BY_STORE":
      return <ChallanList />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const ChallanQrCodeListRoute = () => {
  const { userProfileRole } = getUserData();
  switch (userProfileRole) {
    case "BY_STORE":
      return <ChallanQrCodeList />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const StoreProfileRoute = () => {
  const { userProfileRole } = getUserData();
  switch (userProfileRole) {
    case "BY_STORE":
      return <StoreProfile />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const StoreGarmentStockRoute = () => {
  const { userProfileRole } = getUserData();
  switch (userProfileRole) {
    case "BY_STORE":
      return <StoreGarmentStock />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const ThankYouRoute = () => {
  const { userProfileRole } = getUserData();
  switch (userProfileRole) {
    case "BY_STORE":
      return <ThankYou />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const ThankYouCollectPaymentRoute = () => {
  const { userProfileRole } = getUserData();
  switch (userProfileRole) {
    case "BY_STORE":
      return <ThankYouCollectPayment />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const GarmentQrCodeListRoute = () => {
  const { userProfileRole } = getUserData();
  switch (userProfileRole) {
    case "BY_ADMIN":
      return <GarmentQrCodeListAdmin />;
    case "BY_SUB_ADMIN_USER":
      return <GarmentQrCodeListAdmin />;
    case "BY_FRANCHISE_ADMIN":
      return <GarmentQrCodeListAdmin />;
    case "BY_STORE":
      return <GarmentQrCodeList />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const DashboardPaymentRefundRoute = () => {
  const { userProfileRole } = getUserData();
  switch (userProfileRole) {
    case "BY_ADMIN":
      return <DashboardPaymentRefund />;
      case "BY_SUB_ADMIN_USER":
        return <DashboardPaymentRefund />;
    case "BY_STORE":
      return <DashboardPaymentRefund />;
      case "BY_FRANCHISE_ADMIN": 
      return <DashboardPaymentRefund />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const PaymentCollectionReceiptRoute = () => {
  const { userProfileRole } = getUserData();
  switch (userProfileRole) {
    case "BY_ADMIN":
      return <PaymentCollectionReceiptAdmin />;
    case "BY_SUB_ADMIN_USER":
      return <PaymentCollectionReceiptAdmin />;
    case "BY_FRANCHISE_ADMIN":
      return <PaymentCollectionReceiptAdmin />;
    case "BY_STORE":
      return <PaymentCollectionReceipt />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const PackagePaymentReceiptRoute = () => {
  const { userProfileRole } = getUserData();
  switch (userProfileRole) {
    case "BY_ADMIN":
      return <PackagePaymentReceiptAdmin />;
    case "BY_SUB_ADMIN_USER":
      return <PackagePaymentReceiptAdmin />;
    case "BY_STORE":
      return <PackagePaymentReceipt />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const ViewQrCodePrintRoute = () => {
  const { userProfileRole } = getUserData();
  switch (userProfileRole) {
    case "BY_STORE":
      return <ViewQrCodePrint />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const RiderChallanComponentRoute = () => {
  const { userProfileRole } = getUserData();
  switch (userProfileRole) {
    case "BY_ADMIN":
      return <RiderChallanComponent />;
    case "BY_SUB_ADMIN_USER":
      return <RiderChallanComponent />;
    case "BY_FRANCHISE_ADMIN":
      return <RiderChallanComponent />;
    case "BY_STORE":
      return <RiderChallanComponent />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const ChallanReceiptRoute = () => {
  const { userProfileRole } = getUserData();
  switch (userProfileRole) {
    case "BY_STORE":
      return <ChallanReceipt />;
    case "BY_WAREHOUSE":
      return <WarehouseChallanReceipt />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

// Warehouse Pages

export const WarehouseDashboardQrCodeListRoute = () => {
  const { userProfileRole } = getUserData();
  switch (userProfileRole) {
    case "BY_WAREHOUSE":
      return <WarehouseDashboardQrCodeList />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const WarehouseDashboardQrCodeListReceivedReadyRoute = () => {
  const { userProfileRole } = getUserData();
  switch (userProfileRole) {
    case "BY_WAREHOUSE":
      return <WarehouseDashboardQrCodeListReceivedReady />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const WarehouseGarmentInspectionImagesRoute = () => {
  const { userProfileRole } = getUserData();

  switch (userProfileRole) {
    case "BY_STORE":
      return <WarehouseGarmentInspectionImages />;
    case "BY_WAREHOUSE":
      return <WarehouseGarmentInspectionImages />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const WarehouseChallanListRoute = () => {
  const { userProfileRole } = getUserData();

  switch (userProfileRole) {
    case "BY_WAREHOUSE":
      return <WarehouseChallanList />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const WarehouseChallanQrCodeListRoute = () => {
  const { userProfileRole } = getUserData();

  switch (userProfileRole) {
    case "BY_WAREHOUSE":
      return <WarehouseChallanQrCodeList />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const ReceiveFromStoreRoute = () => {
  const { userProfileRole } = getUserData();

  switch (userProfileRole) {
    case "BY_WAREHOUSE":
      return <ReceiveFromStore />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const WarehouseOrderProcessRoute = () => {
  const { userProfileRole } = getUserData();

  switch (userProfileRole) {
    case "BY_WAREHOUSE":
      return <WarehouseOrderProcess />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const SendToStoreRoute = () => {
  const { userProfileRole } = getUserData();

  switch (userProfileRole) {
    case "BY_WAREHOUSE":
      return <SendToStore />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

// Role Admin

export const SelectStoreInAdminRoute = () => {
  const { userProfileRole } = getUserData();

  switch (userProfileRole) {
    case "BY_ADMIN":
      return <SelectStoreInAdmin />;
      case "BY_SUB_ADMIN_USER":
        return <SelectStoreInAdmin />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

// Role ADmin Setting

export const UserListRoute = () => {
  const { userProfileRole } = getUserData();

  switch (userProfileRole) {
    case "BY_ADMIN":
      return <UserList />;
      case "BY_SUB_ADMIN_USER":
        return <UserList />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const StoreManagementListRoute = () => {
  const { userProfileRole } = getUserData();

  switch (userProfileRole) {
    case "BY_ADMIN":
      return <StoreManagementList />;
      case "BY_SUB_ADMIN_USER":
        return <StoreManagementList />;
        case "BY_FRANCHISE_ADMIN": 
        return <StoreManagementList />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const StoreManagementCreateRoute = () => {
  const { userProfileRole } = getUserData();

  switch (userProfileRole) {
    case "BY_ADMIN":
      return <StoreManagementCreate />;
      case "BY_SUB_ADMIN_USER":
        return <StoreManagementCreate />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const StoreConfigListRoute = () => {
  const { userProfileRole } = getUserData();

  switch (userProfileRole) {
    case "BY_ADMIN":
      return <StoreConfigList />;
      case "BY_SUB_ADMIN_USER":
        return <StoreConfigList />;
        case "BY_FRANCHISE_ADMIN": 
        return <StoreConfigList />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const StoreConfigUserRoute = () => {
  const { userProfileRole } = getUserData();

  switch (userProfileRole) {
    case "BY_ADMIN":
      return <StoreConfigUser />;
    case "BY_SUB_ADMIN_USER":
      return <StoreConfigUser />;
    case "BY_FRANCHISE_ADMIN":
      return <StoreConfigUser />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};
export const StoreConfigPriceRoute = () => {
  const { userProfileRole } = getUserData();

  switch (userProfileRole) {
    case "BY_ADMIN":
      return <StoreConfigPrice />;
    case "BY_SUB_ADMIN_USER":
      return <StoreConfigPrice />;
    case "BY_FRANCHISE_ADMIN":
      return <StoreConfigPrice />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const StoreConfigPackageRoute = () => {
  const { userProfileRole } = getUserData();

  switch (userProfileRole) {
    case "BY_ADMIN":
      return <StoreConfigPackage />;
    case "BY_SUB_ADMIN_USER":
      return <StoreConfigPackage />;
    case "BY_FRANCHISE_ADMIN":
      return <StoreConfigPackage />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const StoreConfigChargesRoute = () => {
  const { userProfileRole } = getUserData();

  switch (userProfileRole) {
    case "BY_ADMIN":
      return <StoreConfigCharges />;
    case "BY_SUB_ADMIN_USER":
      return <StoreConfigCharges />;
    case "BY_FRANCHISE_ADMIN":
      return <StoreConfigCharges />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const StoreConfigDiscountRoute = () => {
  const { userProfileRole } = getUserData();

  switch (userProfileRole) {
    case "BY_ADMIN":
      return <StoreConfigDiscount />;
    case "BY_SUB_ADMIN_USER":
      return <StoreConfigDiscount />;
    case "BY_FRANCHISE_ADMIN":
      return <StoreConfigDiscount />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const StoreConfigOfferRoute = () => {
  const { userProfileRole } = getUserData();

  switch (userProfileRole) {
    case "BY_ADMIN":
      return <StoreConfigOffer />;
    case "BY_SUB_ADMIN_USER":
      return <StoreConfigOffer />;
    case "BY_FRANCHISE_ADMIN":
      return <StoreConfigOffer />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const StoreConfigPackageOfferRoute = () => {
  const { userProfileRole } = getUserData();

  switch (userProfileRole) {
    case "BY_ADMIN":
      return <StoreConfigPackageOffer />;
    case "BY_SUB_ADMIN_USER":
      return <StoreConfigPackageOffer />;
    case "BY_FRANCHISE_ADMIN":
      return <StoreConfigPackageOffer />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const StoreConfigPaymentGatewayViewRoute = () => {
  const { userProfileRole } = getUserData();

  switch (userProfileRole) {
    case "BY_ADMIN":
      return <StoreConfigPaymentGatewayView />;
    case "BY_SUB_ADMIN_USER":
      return <StoreConfigPaymentGatewayView />;
    case "BY_FRANCHISE_ADMIN":
      return <StoreConfigPaymentGatewayView />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const WarehouseManagementListRoute = () => {
  const { userProfileRole } = getUserData();

  switch (userProfileRole) {
    case "BY_ADMIN":
      return <WarehouseManagementList />;
      case "BY_SUB_ADMIN_USER":
    return <WarehouseManagementList />;    
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const WarehouseManagementCreateRoute = () => {
  const { userProfileRole } = getUserData();

  switch (userProfileRole) {
    case "BY_ADMIN":
      return <WarehouseManagementCreate />;
      case "BY_SUB_ADMIN_USER":
        return <WarehouseManagementCreate />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};
export const WarehouseConfigListRoute = () => {
  const { userProfileRole } = getUserData();

  switch (userProfileRole) {
    case "BY_ADMIN":
      return <WarehouseConfigList />;
      case "BY_SUB_ADMIN_USER":
        return <WarehouseConfigList />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const WarehouseConfigStoresRoute = () => {
  const { userProfileRole } = getUserData();

  switch (userProfileRole) {
    case "BY_ADMIN":
      return <WarehouseConfigStores />;
      case "BY_SUB_ADMIN_USER":
        return <WarehouseConfigStores />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const WarehouseConfigUsersRoute = () => {
  const { userProfileRole } = getUserData();

  switch (userProfileRole) {
    case "BY_ADMIN":
      return <WarehouseConfigUsers />;
      case "BY_SUB_ADMIN_USER":
       return <WarehouseConfigUsers />; 
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const WarehouseProcessStageListRoute = () => {
  const { userProfileRole } = getUserData();

  switch (userProfileRole) {
    case "BY_ADMIN":
      return <WarehouseProcessStageList />;
      case "BY_SUB_ADMIN_USER":
         return <WarehouseProcessStageList />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const WarehouseProcessStageUsersRoute = () => {
  const { userProfileRole } = getUserData();

  switch (userProfileRole) {
    case "BY_ADMIN":
      return <WarehouseProcessStageUsers />;
      case "BY_SUB_ADMIN_USER":
        return <WarehouseProcessStageUsers />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const ChargesAndDiscountListRoute = () => {
  const { userProfileRole } = getUserData();

  switch (userProfileRole) {
    case "BY_ADMIN":
      return <ChargesAndDiscountList />;
      case "BY_SUB_ADMIN_USER":
        return <ChargesAndDiscountList />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const AppServiceListRoute = () => {
  const { userProfileRole } = getUserData();

  switch (userProfileRole) {
    case "BY_ADMIN":
      return <AppServiceList />;
      case "BY_SUB_ADMIN_USER":
        return <AppServiceList />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const GarmentPackRoute = () => {
  const { userProfileRole } = getUserData();

  switch (userProfileRole) {
    case "BY_ADMIN":
      return <GarmentPack />;
      case "BY_SUB_ADMIN_USER":
         return <GarmentPack />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const TariffListRoute = () => {
  const { userProfileRole } = getUserData();

  switch (userProfileRole) {
    case "BY_ADMIN":
      return <TariffList />;
      case "BY_SUB_ADMIN_USER":
        return <TariffList />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const PriceListRoute = () => {
  const { userProfileRole } = getUserData();

  switch (userProfileRole) {
    case "BY_ADMIN":
      return <PriceList />;
      case "BY_SUB_ADMIN_USER":
        return <PriceList />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const PackageTariffListRoute = () => {
  const { userProfileRole } = getUserData();

  switch (userProfileRole) {
    case "BY_ADMIN":
      return <PackageTariffList />;
      case "BY_SUB_ADMIN_USER":
              return <PackageTariffList />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const OffersManagementRoute = () => {
  const { userProfileRole } = getUserData();

  switch (userProfileRole) {
    case "BY_ADMIN":
      return <OffersManagement />;
      case "BY_SUB_ADMIN_USER":
        return <OffersManagement />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const OffersManagementCreateRoute = () => {
  const { userProfileRole } = getUserData();

  switch (userProfileRole) {
    case "BY_ADMIN":
      return <OffersManagementCreate />;
      case "BY_SUB_ADMIN_USER":
        return <OffersManagementCreate />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const PackageOfferManagementRoute = () => {
  const { userProfileRole } = getUserData();

  switch (userProfileRole) {
    case "BY_ADMIN":
      return <PackageOfferManagement />;
      case "BY_SUB_ADMIN_USER":
        return <PackageOfferManagement />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const PackageOfferCreateRoute = () => {
  const { userProfileRole } = getUserData();

  switch (userProfileRole) {
    case "BY_ADMIN":
      return <PackageOfferCreate />;
      case "BY_SUB_ADMIN_USER":
        return <PackageOfferCreate />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const BrandTermAndConditionRoute = () => {
  const { userProfileRole } = getUserData();

  switch (userProfileRole) {
    case "BY_ADMIN":
      return <BrandTermAndCondition />;
      case "BY_SUB_ADMIN_USER":
              return <BrandTermAndCondition />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const BrandTermAndConditionCreateRoute = () => {
  const { userProfileRole } = getUserData();

  switch (userProfileRole) {
    case "BY_ADMIN":
      return <BrandTermAndConditionCreate />;
      case "BY_SUB_ADMIN_USER":
        return <BrandTermAndConditionCreate />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const LocalityViewRoute = () => {
  const { userProfileRole } = getUserData();

  switch (userProfileRole) {
    case "BY_ADMIN":
      return <LocalityView />;
      case "BY_SUB_ADMIN_USER":
        return <LocalityView />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const LocalityCreateRoute = () => {
  const { userProfileRole } = getUserData();

  switch (userProfileRole) {
    case "BY_ADMIN":
      return <LocalityCreate />;
      case "BY_SUB_ADMIN_USER":
        return <LocalityCreate />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const PaymentGatewayConfigViewRoute = () => {
  const { userProfileRole } = getUserData();

  switch (userProfileRole) {
    case "BY_ADMIN":
      return <PaymentGatewayConfigView />;
      case "BY_SUB_ADMIN_USER":
        return <PaymentGatewayConfigView />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const PaymentGatewayConfigCreateRoute = () => {
  const { userProfileRole } = getUserData();

  switch (userProfileRole) {
    case "BY_ADMIN":
      return <PaymentGatewayConfigCreate />;
      case "BY_SUB_ADMIN_USER":
        return <PaymentGatewayConfigCreate />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const GarmentRemarksListRoute = () => {
  const { userProfileRole } = getUserData();

  switch (userProfileRole) {
    case "BY_ADMIN":
      return <GarmentRemarksList />;
      case "BY_SUB_ADMIN_USER":
        return <GarmentRemarksList />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const GarmentRemarksDetailListRoute = () => {
  const { userProfileRole } = getUserData();

  switch (userProfileRole) {
    case "BY_ADMIN":
      return <GarmentRemarksDetailList />;
      case "BY_SUB_ADMIN_USER":
        return <GarmentRemarksDetailList />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const GarmentRemarksCreateRoute = () => {
  const { userProfileRole } = getUserData();

  switch (userProfileRole) {
    case "BY_ADMIN":
      return <GarmentRemarksCreate />;
      case "BY_SUB_ADMIN_USER":
        return <GarmentRemarksCreate />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const BrandCustomerListRoute = () => {
  const { userProfileRole } = getUserData();

  switch (userProfileRole) {
    case "BY_ADMIN":
      return <BrandCustomerList />;
      case "BY_SUB_ADMIN_USER":
        return <BrandCustomerList />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const BrandOldOrderRoute = () => {
  const { userProfileRole } = getUserData();

  switch (userProfileRole) {
    case "BY_ADMIN":
      return <BrandOldOrder />;
      case "BY_SUB_ADMIN_USER":
        return <BrandOldOrder />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const AdminDashboardPickupJobRoute = () => {
  const { userProfileRole } = getUserData();

  switch (userProfileRole) {
    case "BY_ADMIN":
      return <AdminDashboardPickupJob />;
    case "BY_SUB_ADMIN_USER":
      return <AdminDashboardPickupJob />;
    case "BY_FRANCHISE_ADMIN":
      return <AdminDashboardPickupJob />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const AdminDashboardDeliveryJobRoute = () => {
  const { userProfileRole } = getUserData();

  switch (userProfileRole) {
    case "BY_ADMIN":
      return <AdminDashboardDeliveryJob />;
    case "BY_SUB_ADMIN_USER":
      return <AdminDashboardDeliveryJob />;
    case "BY_FRANCHISE_ADMIN":
      return <AdminDashboardDeliveryJob />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const StoreNotificationViewRoute = () => {
  const { userProfileRole } = getUserData();

  switch (userProfileRole) {
    case "BY_ADMIN":
      return <StoreNotificationView />;
    case "BY_SUB_ADMIN_USER":
      return <StoreNotificationView />;
    case "BY_FRANCHISE_ADMIN":
      return <StoreNotificationView />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const ReportsRoute = () => {
  const { userProfileRole } = getUserData();

  switch (userProfileRole) {
    case "BY_ADMIN":
      return <AdminReports />;
      case "BY_SUB_ADMIN_USER":
        return <AdminReports />;
    case "BY_STORE":
      return <StoreReports />;
      case "BY_FRANCHISE_ADMIN": 
      return <AdminReports />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const GarmentStockRoute = () => {
  const { userProfileRole } = getUserData();
  switch (userProfileRole) {
    case "BY_ADMIN":
      return <GarmentStock />;
      case "BY_SUB_ADMIN_USER":
        return <GarmentStock />;
        case "BY_FRANCHISE_ADMIN" :
        return <GarmentStock />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const BarChartRoute = () => {
  const { userProfileRole } = getUserData();
  switch (userProfileRole) {
    case "BY_ADMIN":
      return <BarChart />;
      case "BY_SUB_ADMIN_USER":
        return <BarChart />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const AnalyticsListRoute = () => {
  const { userProfileRole } = getUserData();
  switch (userProfileRole) {
    case "BY_ADMIN":
      return <AnalyticsList />;
      case "BY_SUB_ADMIN_USER":
        return <AnalyticsList />;
        case "BY_FRANCHISE_ADMIN":
          return <AnalyticsList />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const OrderSaleAnalyticsNewRoute = () => {
  const { userProfileRole } = getUserData();
  switch (userProfileRole) {
    case "BY_ADMIN":
      return <OrderSaleAnalyticsNew />;
      case "BY_SUB_ADMIN_USER":
        return <OrderSaleAnalyticsNew />;
        case "BY_FRANCHISE_ADMIN": 
        return <OrderSaleAnalyticsNew />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const TopPerformerNewRoute = () => {
  const { userProfileRole } = getUserData();
  switch (userProfileRole) {
    case "BY_ADMIN":
      return <TopPerformerNew />;
    case "BY_SUB_ADMIN_USER":
      return <TopPerformerNew />;
    case "BY_FRANCHISE_ADMIN":
      return <TopPerformerNew />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const TopServicesNewRoute = () => {
  const { userProfileRole } = getUserData();
  switch (userProfileRole) {
    case "BY_ADMIN":
      return <TopServicesNew />;
    case "BY_SUB_ADMIN_USER":
      return <TopServicesNew />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const TopGarmentsNewRoute = () => {
  const { userProfileRole } = getUserData();
  switch (userProfileRole) {
    case "BY_ADMIN":
      return <TopGarmentsNew />;
    case "BY_SUB_ADMIN_USER":
      return <TopGarmentsNew />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const ProcessStatusRoute = () => {
  const { userProfileRole } = getUserData();
  switch (userProfileRole) {
    case "BY_ADMIN":
      return <ProcessStatus />;
    case "BY_SUB_ADMIN_USER":
      return <ProcessStatus />;
    case "BY_FRANCHISE_ADMIN":
      return <ProcessStatus />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const OverallRevenueRoute = () => {
  const { userProfileRole } = getUserData();
  switch (userProfileRole) {
    case "BY_ADMIN":
      return <OverallRevenue />;
      case "BY_SUB_ADMIN_USER":
        return <OverallRevenue />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const CustomerOldOrderLedgerRoute = () => {
  const { userProfileRole } = getUserData();
  switch (userProfileRole) {
    case "BY_ADMIN":
      return <CustomerOldOrderLedger />;
    case "BY_SUB_ADMIN_USER":
      return <CustomerOldOrderLedger />;
    case "BY_STORE":
      return <CustomerOldOrderLedger />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const WarehouseDashboardQrCodeListStageWiseRoute = () => {
  const { userProfileRole } = getUserData();
  switch (userProfileRole) {
    case "BY_WAREHOUSE":
      return <WarehouseDashboardQrCodeListStageWise />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const SubscriptionAppliedSuccessfullyRoute = () => {
  const { userProfileRole } = getUserData();
  switch (userProfileRole) {
    case "BY_STORE":
      return <SubscriptionAppliedSuccessfully />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const CashbookRoute = () => {
  const { userProfileRole } = getUserData();
  switch (userProfileRole) {
    case "BY_ADMIN":
      return <Cashbook />;
      case "BY_SUB_ADMIN_USER":
        return <Cashbook />;
    case "BY_STORE":
      return <StoreCashbook />;
      case "BY_FRANCHISE_ADMIN": 
      return <Cashbook />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const IncomeExpenseRoute = () => {
  const { userProfileRole } = getUserData();
  switch (userProfileRole) {
    case "BY_ADMIN":
      return <IncomeExpense />;
      case "BY_SUB_ADMIN_USER":
        return <IncomeExpense />;
    case "BY_STORE":
      return <StoreIncomeExpense />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const IncomeExpenseSelectionRoute = () => {
  const { userProfileRole } = getUserData();
  switch (userProfileRole) {
    case "BY_ADMIN":
      return <IncomeExpenseSelection />;
      case "BY_SUB_ADMIN_USER":
        return <IncomeExpenseSelection />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const StoreWiseIncomeExpenseRoute = () => {
  const { userProfileRole } = getUserData();
  switch (userProfileRole) {
    case "BY_ADMIN":
      return <StoreWiseIncomeExpense />;
      case "BY_SUB_ADMIN_USER":
        return <StoreWiseIncomeExpense />;
        case "BY_FRANCHISE_ADMIN": 
        return <StoreWiseIncomeExpense />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const DashboardPaymentCollectionReceiptRoute = () => {
  const { userProfileRole } = getUserData();
  switch (userProfileRole) {
    case "BY_ADMIN":
      return <DashboardPaymentCollectionReceipt />;
      case "BY_SUB_ADMIN_USER":
        return <DashboardPaymentCollectionReceipt />;
    case "BY_STORE":
      return <DashboardPaymentCollectionReceipt />;
      case "BY_FRANCHISE_ADMIN":
        return <DashboardPaymentCollectionReceipt />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const ReportsViewRoute = () => {
  const { userProfileRole } = getUserData();
  switch (userProfileRole) {
    case "BY_ADMIN":
      return <ReportsView />;
    case "BY_SUB_ADMIN_USER":
      return <ReportsView />;
    case "BY_FRANCHISE_ADMIN":
      return <ReportsView />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const UPIDisclaimerRoute = () => {
  const { userProfileRole } = getUserData();
  switch (userProfileRole) {
    case "BY_ADMIN":
      return <UPIDisclaimer />;
      case "BY_SUB_ADMIN_USER":
         return <UPIDisclaimer />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const ReadyToSendToWareHouseRoute = () => {
  const { userProfileRole } = getUserData();
  switch (userProfileRole) {
    case "BY_STORE":
      return <ReadyToSendToWareHouse />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const ReadyToSendToStoreByWarehouseRoute = () => {
  const { userProfileRole } = getUserData();
  switch (userProfileRole) {
    case "BY_WAREHOUSE":
      return <ReadyToSendToStoreByWarehouse />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const OrderDeliveredComponentRoute = () => {
  const { userProfileRole } = getUserData();
  switch (userProfileRole) {
    case "BY_ADMIN":
      return <OrderDeliveredComponentAdmin />;
    case "BY_SUB_ADMIN_USER":
      return <OrderDeliveredComponentAdmin />;
    case "BY_STORE":
      return <OrderDeliveredComponent />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const OrderDeliveredComponentMenuRoute = () => {
  const { userProfileRole } = getUserData();
  switch (userProfileRole) {
    case "BY_STORE":
      return <OrderDeliveredComponentMenu />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const QrCodeByItemRoute = () => {
  const { userProfileRole } = getUserData();
  switch (userProfileRole) {
    case "BY_ADMIN":
      return <QrCodeByItem />;
      case "BY_SUB_ADMIN_USER":
        return <QrCodeByItem />;
    case "BY_STORE":
      return <QrCodeByItem />;
    case "BY_RIDER":
      return <QrCodeByItem />;
      case "BY_FRANCHISE_ADMIN": 
      return <QrCodeByItem />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const StoreExternalWarehouseChallanRoute = () => {
  const { userProfileRole } = getUserData();
  switch (userProfileRole) {
    case "BY_STORE":
      return <StoreExternalWarehouseChallan />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const StoreExternalWarehouseChallanAddRoute = () => {
  const { userProfileRole } = getUserData();
  switch (userProfileRole) {
    case "BY_STORE":
      return <StoreExternalWarehouseChallanAdd />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const StoreExternalWarehouseQrCodeRoute = () => {
  const { userProfileRole } = getUserData();
  switch (userProfileRole) {
    case "BY_STORE":
      return <StoreExternalWarehouseQrCode />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const StoreExternalWarehouseChallanQrcodeDataRoute = () => {
  const { userProfileRole } = getUserData();
  switch (userProfileRole) {
    case "BY_STORE":
      return <StoreExternalWarehouseChallanQrcodeData />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const StoreExternalWHChallanComponentRoute = () => {
  const { userProfileRole } = getUserData();
  switch (userProfileRole) {
    case "BY_STORE":
      return <StoreExternalWHChallanComponent />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const StorePrinterSettingRoute = () => {
  const { userProfileRole } = getUserData();
  switch (userProfileRole) {
    case "BY_STORE":
      return <StorePrinterSetting />;
    case "BY_ADMIN":
      return <StorePrinterSetting />;
      case "BY_SUB_ADMIN_USER":
        return <StorePrinterSetting />;
    case "BY_WAREHOUSE":
      return <StorePrinterSetting />;
      case "BY_FRANCHISE_ADMIN":
        return <StorePrinterSetting />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const BulkProcessingListRoute = () => {
  const { userProfileRole } = getUserData();
  switch (userProfileRole) {
    case "BY_STORE":
      return <BulkProcessingList />;
    case "BY_ADMIN":
      return <BulkProcessingList />;
      case "BY_SUB_ADMIN_USER":
        return <BulkProcessingList />;
        case "BY_FRANCHISE_ADMIN": 
        return <BulkProcessingList />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const BulkProcessingRoute = () => {
  const { userProfileRole } = getUserData();
  switch (userProfileRole) {
    case "BY_STORE":
      return <BulkProcessing />;
    case "BY_ADMIN":
      return <BulkProcessingAdmin />;
      case "BY_SUB_ADMIN_USER":
        return <BulkProcessingAdmin />;
        case "BY_FRANCHISE_ADMIN": 
        return <BulkProcessingAdmin />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const BulkOutForDeliveryRoute = () => {
  const { userProfileRole } = getUserData();
  switch (userProfileRole) {
    case "BY_STORE":
      return <BulkOutForDelivery />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const StoreReportCollectionReceiptRoute = () => {
  const { userProfileRole } = getUserData();
  switch (userProfileRole) {
    case "BY_STORE":
      return <StoreReportCollectionReceipt />;
    case "BY_ADMIN":
      return <StoreReportCollectionReceipt />;
      case "BY_SUB_ADMIN_USER":
        return <StoreReportCollectionReceipt />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const WalletCollectionReceiptRoute = () => {
  const { userProfileRole } = getUserData();
  switch (userProfileRole) {
    case "BY_ADMIN":
      return <WalletCollectionReceipt />;
      case "BY_SUB_ADMIN_USER":
        return <WalletCollectionReceipt />;
    case "BY_STORE":
      return <WalletCollectionReceipt />;
      case "BY_FRANCHISE_ADMIN": 
      return <WalletCollectionReceipt />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const TariffManagementRoute = () => {
  const { userProfileRole } = getUserData();
  switch (userProfileRole) {
    case "BY_ADMIN":
      return <TariffManagement />;
      case "BY_SUB_ADMIN_USER":
        return <TariffManagement />;
    case "BY_STORE":
      return <TariffManagement />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const PriceListSelectionRoute = () => {
  const { userProfileRole } = getUserData();
  switch (userProfileRole) {
    case "BY_ADMIN":
      return <PriceListSelection />;
      case "BY_SUB_ADMIN_USER":
        return <PriceListSelection />;
    case "BY_STORE":
      return <PriceListSelectionByStore />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const PackageListSelectionRoute = () => {
  const { userProfileRole } = getUserData();
  switch (userProfileRole) {
    case "BY_ADMIN":
      return <PackageListSelection />;
      case "BY_SUB_ADMIN_USER":
        return <PackageListSelection />;
      case "BY_STORE":
        return <PackageListSelectionByStore />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};
export const PriceListTariffRoute = () => {
  const { userProfileRole } = getUserData();
  switch (userProfileRole) {
    case "BY_ADMIN":
      return <PriceListTariff />;
      case "BY_SUB_ADMIN_USER":
        return <PriceListTariff />;
      case "BY_STORE":
        return <PriceListTariff />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};
export const MyPriceListTariffRoute = () => {
  const { userProfileRole } = getUserData();
  switch (userProfileRole) {
    case "BY_ADMIN":
      return <MyPriceListTariff />;
      case "BY_SUB_ADMIN_USER":
        return <MyPriceListTariff />;
      case "BY_STORE":
        return <MyPriceListTariff />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};
export const PackageListRoute = () => {
  const { userProfileRole } = getUserData();
  switch (userProfileRole) {
    case "BY_ADMIN":
      return <PackageList />;
      case "BY_SUB_ADMIN_USER":
        return <PackageList />;
      case "BY_STORE":
        return <PackageList />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};
export const MyPackageListRoute = () => {
  const { userProfileRole } = getUserData();
  switch (userProfileRole) {
    case "BY_ADMIN":
      return <MyPackageList />;
      case "BY_SUB_ADMIN_USER":
        return <MyPackageList />;
      case "BY_STORE":
        return <MyPackageList />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};
export const GarmentTagRoute = () => {
  const { userProfileRole } = getUserData();
  switch (userProfileRole) {
    case "BY_STORE":
      return <GarmentTag />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const OfferManagementRoute = () => {
  const { userProfileRole } = getUserData();
  switch (userProfileRole) {
    case "BY_ADMIN":
      return <OfferManagement />;
      case "BY_SUB_ADMIN_USER":
        return <OfferManagement />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};
export const OfferGarmentSelectionRoute = () => {
  const { userProfileRole } = getUserData();
  switch (userProfileRole) {
    case "BY_ADMIN":
      return <OfferGarmentSelection />;
      case "BY_SUB_ADMIN_USER":
        return <OfferGarmentSelection />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};
export const MyOfferGarmentSelectionRoute = () => {
  const { userProfileRole } = getUserData();
  switch (userProfileRole) {
    case "BY_ADMIN":
      return <MyOfferGarmentSelection />;
      case "BY_SUB_ADMIN_USER":
        return <MyOfferGarmentSelection />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};
export const TrackOrderRoute = () => {
  const { userProfileRole } = getUserData();
  switch (userProfileRole) {
    case "BY_ADMIN":
      return <TrackOrder />;
      case "BY_SUB_ADMIN_USER":
        return <TrackOrder />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const WhatsappNotificationRoute = () => {
  const { userProfileRole } = getUserData();
  switch (userProfileRole) {
    case "BY_ADMIN":
      return <WhatsappNotificationAdmin />;
      case "BY_SUB_ADMIN_USER":
        return <WhatsappNotificationAdmin />;
      case "BY_STORE":
        return <WhatsappNotification />;
        case "BY_FRANCHISE_ADMIN": 
        return <WhatsappNotificationAdmin />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const TimeSlotListRoute = () => {
  const { userProfileRole } = getUserData();
  switch (userProfileRole) {
    case "BY_ADMIN":
        return <TimeSlotList />;
        case "BY_SUB_ADMIN_USER":
          return <TimeSlotList />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const TimeSlotCreateRoute = () => {
  const { userProfileRole } = getUserData();
  switch (userProfileRole) {
    case "BY_ADMIN":
        return <TimeSlotCreate />;
        case "BY_SUB_ADMIN_USER":
           return <TimeSlotCreate />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const PackageLogRoute = () => {
  const { userProfileRole } = getUserData();
  switch (userProfileRole) {
    case "BY_ADMIN":
        return <PackageLogAdminWithUpdate />;
        case "BY_SUB_ADMIN_USER":
        return <PackageLogAdmin />;  
    case "BY_STORE":
        return <PackageLogStore />;
        case "BY_FRANCHISE_ADMIN": 
        return <PackageLogAdmin />;  
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const CustomerSubscriptionRoute = () => {
  const { userProfileRole } = getUserData();
  switch (userProfileRole) {
    case "BY_ADMIN":
      return <CustomerSubscription />;
    case "BY_SUB_ADMIN_USER":
      return <CustomerSubscription />;
    case "BY_STORE":
      return <CustomerSubscription />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};



export const SubscriptionPackageRoute = () => {
  const { userProfileRole } = getUserData();
  switch (userProfileRole) {
    case "BY_ADMIN":
        return <SubscriptionPackage />;
        case "BY_SUB_ADMIN_USER":
           return <SubscriptionPackage />;
    case "BY_STORE":
        return <SubscriptionPackage />;
        case "BY_FRANCHISE_ADMIN": 
        return <SubscriptionPackage />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const SubscriptionPackageInfoStoreRoute = () => {
  const { userProfileRole } = getUserData();
  switch (userProfileRole) {
     case "BY_ADMIN":
        return <SubscriptionPackageInfoAdmin />;
        case "BY_SUB_ADMIN_USER":
          return <SubscriptionPackageInfoAdmin />;
    case "BY_STORE":
        return <SubscriptionPackageInfoStore />;
        case "BY_FRANCHISE_ADMIN":
          return <SubscriptionPackageInfoAdmin />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const AllCustomerPackageOfferLogRoute = () => {
  const { userProfileRole } = getUserData();
  switch (userProfileRole) {
    case "BY_ADMIN":
      return <AllCustomerPackageOfferLog />;
    case "BY_SUB_ADMIN_USER":
      return <AllCustomerPackageOfferLog />;
    case "BY_STORE":
      return <AllCustomerPackageOfferLog />;
    case "BY_FRANCHISE_ADMIN":
      return <AllCustomerPackageOfferLog />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const CustomerPackageLogRoute = () => {
  const { userProfileRole } = getUserData();
  switch (userProfileRole) {
    case "BY_ADMIN":
      return <CustomerPackageLog />;
    case "BY_SUB_ADMIN_USER":
      return <CustomerPackageLog />;
    case "BY_STORE":
      return <CustomerPackageLog />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const LoyaltyPointListRoute = () => {
  const { userProfileRole } = getUserData();
  switch (userProfileRole) {
    case "BY_ADMIN":
        return <LoyaltyPointList />;
        case "BY_SUB_ADMIN_USER":
          return <LoyaltyPointList />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const CustomerLoyaltyPointLogRoute = () => {
  const { userProfileRole } = getUserData();
  switch (userProfileRole) {
    case "BY_ADMIN":
      return <CustomerLoyaltyPointLog />;
    case "BY_SUB_ADMIN_USER":
      return <CustomerLoyaltyPointLog />;
    case "BY_STORE":
      return <CustomerLoyaltyPointLog />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const CustomerLoyaltyPointPointLogRoute = () => {
  const { userProfileRole } = getUserData();
  switch (userProfileRole) {
    case "BY_ADMIN":
      return <CustomerLoyaltyPointPointLog />;
    case "BY_SUB_ADMIN_USER":
      return <CustomerLoyaltyPointPointLog />;
    case "BY_STORE":
      return <CustomerLoyaltyPointPointLog />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const CustomerLoyaltyPointCashLogRoute = () => {
  const { userProfileRole } = getUserData();
  switch (userProfileRole) {
    case "BY_ADMIN":
      return <CustomerLoyaltyPointCashLog />;
    case "BY_SUB_ADMIN_USER":
      return <CustomerLoyaltyPointCashLog />;
    case "BY_STORE":
      return <CustomerLoyaltyPointCashLog />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const LoyaltyPointRedeemNowRoute = () => {
  const { userProfileRole } = getUserData();
  switch (userProfileRole) {
    case "BY_STORE":
        return <LoyaltyPointRedeemNow />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};


export const FranchiseListRoute = () => {
  const { userProfileRole } = getUserData();
  switch (userProfileRole) {
    case "BY_ADMIN":
      return <FranchiseManagementList />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const FranchiseCreateRoute = () => {
  const { userProfileRole } = getUserData();
  switch (userProfileRole) {
    case "BY_ADMIN":
      return <FranchiseManagementCreate />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const FranchiseStoreMappedListRoute = () => {
  const { userProfileRole } = getUserData();
  switch (userProfileRole) {
    case "BY_ADMIN":
      return <FranchiseStoreMappedList />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const FranchiseStoreMapRoute = () => {
  const { userProfileRole } = getUserData();
  switch (userProfileRole) {
    case "BY_ADMIN":
      return <FranchiseStoreMap />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};


export const FranchiseConfigListRoute = () => {
  const { userProfileRole } = getUserData();
  switch (userProfileRole) {
    case "BY_ADMIN":
      return <FranchiseConfigList />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const FranchisesRateListRoute = () => {
  const { userProfileRole } = getUserData();
  switch (userProfileRole) {
    case "BY_ADMIN":
      return <FranchisesRateList />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const FranchisesRateCreateRoute = () => {
  const { userProfileRole } = getUserData();
  switch (userProfileRole) {
    case "BY_ADMIN":
      return <FranchisesRateCreate />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const FranchiseUserMapRoute = () => {
  const { userProfileRole } = getUserData();
  switch (userProfileRole) {
    case "BY_ADMIN":
      return <FranchiseUserMap />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const FranchiseUserMappedListRoute = () => {
  const { userProfileRole } = getUserData();
  switch (userProfileRole) {
    case "BY_ADMIN":
      return <FranchiseUserMappedList />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const FranchiseStoreOrderRevenueRoute = () => {
  const { userProfileRole } = getUserData();
  switch (userProfileRole) {
    case "BY_ADMIN":
      return <FranchiseStoreOrderRevenueAdmin />;
    case "BY_FRANCHISE_ADMIN":
      return <FranchiseStoreOrderRevenue />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const FranchiseStoreServiceWiseRevenueRoute = () => {
  const { userProfileRole } = getUserData();
  switch (userProfileRole) {
    case "BY_ADMIN":
      return <FranchiseStoreServiceWiseRevenueAdmin />;
    case "BY_FRANCHISE_ADMIN":
      return <FranchiseStoreServiceWiseRevenue />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const FranchiseStoreListRoute = () => {
  const { userProfileRole } = getUserData();
  switch (userProfileRole) {
    case "BY_ADMIN":
      return <FranchiseStoreListAdmin />;
      case "BY_FRANCHISE_ADMIN":
      return <FranchiseStoreList />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }

};

export const GarmentRFIDListRoute = () => {
  const { userProfileRole } = getUserData();
  switch (userProfileRole) {
    // case "BY_ADMIN":
    //   return <GarmentRFIDListAdmin />;
    // case "BY_SUB_ADMIN_USER":
    //   return <GarmentRFIDListAdmin />;
    // case "BY_FRANCHISE_ADMIN":
    //   return <GarmentRFIDListAdmin />;
    case "BY_STORE":
      return <GarmentRFIDList />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const CheckGarmentRFIDRoute = () => {
  const { userProfileRole } = getUserData();
  switch (userProfileRole) {
    // case "BY_ADMIN":
    //   return <GarmentRFIDListAdmin />;
    // case "BY_SUB_ADMIN_USER":
    //   return <GarmentRFIDListAdmin />;
    // case "BY_FRANCHISE_ADMIN":
    //   return <GarmentRFIDListAdmin />;
    case "BY_STORE":
      return <CheckGarmentRFID />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const StoreCustomerIdConfigListRoute = () => {
  const { userProfileRole } = getUserData();
  switch (userProfileRole) {
    case "BY_ADMIN":
      return <StoreCustomerIdConfigList />;
     
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const StoreCustomerIdConfigAddRoute = () => {
  const { userProfileRole } = getUserData();
  switch (userProfileRole) {
    case "BY_ADMIN":
      return <StoreCustomerIdConfigAdd />;

    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const BrandBannerViewRoute = () => {
  const { userProfileRole } = getUserData();
  switch (userProfileRole) {
    case "BY_ADMIN":
      return <BrandBannerView />;

    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const PromoTemplateViewRoute = () => {
  const { userProfileRole } = getUserData();

  switch (userProfileRole) {
    case "BY_ADMIN":
      return <PromoTemplateView />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const PromoTemplateCreateRoute = () => {
  const { userProfileRole } = getUserData();

  switch (userProfileRole) {
    case "BY_ADMIN":
      return <PromoTemplateCreate />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const PromoTemplateCustomerViewRoute = () => {
  const { userProfileRole } = getUserData();

  switch (userProfileRole) {
    case "BY_ADMIN":
      return <PromoTemplateCustomerView />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const PaymentModeListRoute = () => {
  const { userProfileRole } = getUserData();
  switch (userProfileRole) {
    case "BY_ADMIN":
      return <PaymentModeList />;
    case "BY_SUB_ADMIN_USER":
      return <PaymentModeList />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const PaymentModeCreateRoute = () => {
  const { userProfileRole } = getUserData();
  switch (userProfileRole) {
    case "BY_ADMIN":
      return <PaymentModeCreate />;
    case "BY_SUB_ADMIN_USER":
      return <PaymentModeCreate />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

// B2B

export const B2BOrdersGarmentInfoRoute = () => {
  const { userProfileRole } = getUserData();
  switch (userProfileRole) {
    case "BY_ADMIN":
      return <B2BAdminOrdersGarmentInfo />;
    case "BY_SUB_ADMIN_USER":
      return <B2BAdminOrdersGarmentInfo />;
    case "BY_STORE":
      return <B2BOrdersGarmentInfo />;
    case "BY_FRANCHISE_ADMIN":
      return <B2BAdminOrdersGarmentInfo />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const B2BChallanListRoute = () => {
  const { userProfileRole } = getUserData();
  switch (userProfileRole) {
    case "BY_ADMIN":
      return <B2BChallanAdminList />;
    case "BY_STORE":
      return <B2BChallanList />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const B2BDeliveredChallanViewListRoute = () => {
  const { userProfileRole } = getUserData();
  switch (userProfileRole) {
    // case "BY_ADMIN":
      // return <B2BDeliveredChallanViewAdminList />;
    case "BY_STORE":
      return <B2BDeliveredChallanViewList />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const B2BGetAllOrderRoute = () => {
  const { userProfileRole } = getUserData();
  switch (userProfileRole) {
    case "BY_ADMIN":
      return <B2BChallanAdminList />;
    case "BY_STORE":
      return <B2BGetAllOrder />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const RackModelRoute = () => {
  const { userProfileRole } = getUserData();
  switch (userProfileRole) {
    case "BY_STORE":
      return <RackModelStore />;
    case "BY_ADMIN":
      return <RackModelAdmin />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const PackageTagViewRoute = () => {
  const { userProfileRole } = getUserData();
  switch (userProfileRole) {
    case "BY_STORE":
      return <PackageTagView />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const B2BChallanComponentRoute = () => {
  const { userProfileRole } = getUserData();
  switch (userProfileRole) {
    case "BY_STORE":
      return <B2BChallanComponent />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const GeoLocationRoute = () => {
  const { userProfileRole } = getUserData();
  switch (userProfileRole) {
    case "BY_ADMIN":
      return <GeoLocationView />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const CustomerFeedBackRoute = () => {
  const { userProfileRole } = getUserData();
  switch (userProfileRole) {
    case "BY_ADMIN":
      return <CustomerFeedBack />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const SwitchRiderUserListRoute = () => {
  const { userProfileRole } = getUserData();
  switch (userProfileRole) {
    case "BY_ADMIN":
      return <SwitchRiderUserList />;
    case "BY_SUB_ADMIN_USER":
      return <SwitchRiderUserList />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const B2BChallanPrintRoute = () => {
  const { userProfileRole } = getUserData();
  switch (userProfileRole) {
    case "BY_ADMIN":
      return <B2BChallanPrint />;
    case "BY_STORE":
      return <B2BChallanPrint />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const CustomerAddressLocationRoute = () => {
  const { userProfileRole } = getUserData();
  switch (userProfileRole) {
    case "BY_STORE":
      return <CustomerAddressLocation />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};


export const PickupDeliveryMapRoute = () => {
  const { userProfileRole } = getUserData();
  switch (userProfileRole) {
    case "BY_STORE":
      return <PickupDeliveryMap />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};

export const StorePartialBookingRoute = () => {
  const { userProfileRole } = getUserData();
  switch (userProfileRole) {
    case "BY_STORE":
      return <StorePartialBooking />;
    default:
      return <div>Unauthorized Access</div>; // Or redirect to login
  }
};






